import { Reveal } from "@/components/Reveal";
import { PageHeader } from "@/pages/Services";
import { useCollection } from "@/hooks/useCollection";
import { useSettings } from "@/context/SettingsContext";
import { MapPin, Briefcase, ArrowRight } from "lucide-react";

export default function Careers() {
  const { items } = useCollection("careers");
  const s = useSettings();
  return (
    <div>
      <PageHeader eyebrow="Karir" title="Bergabung Bersama Kami" subtitle="Wujudkan potensi terbaikmu bersama tim teknologi yang inovatif dan berkembang." />
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12 py-16 sm:py-24">
        <div className="space-y-5">
          {items.map((c, i) => (
            <Reveal key={c.id} delay={i * 0.06}>
              <div className="bg-ll-card rounded-2xl p-7 gold-border flex flex-col md:flex-row md:items-center gap-5 justify-between card-hover" data-testid={`career-card-${i}`}>
                <div>
                  <h3 className="font-syne font-semibold text-xl text-white">{c.title}</h3>
                  <div className="flex flex-wrap gap-4 mt-2 text-sm text-white/60">
                    <span className="flex items-center gap-1"><Briefcase className="w-4 h-4 text-gold" /> {c.type}</span>
                    <span className="flex items-center gap-1"><MapPin className="w-4 h-4 text-gold" /> {c.location}</span>
                  </div>
                  <p className="text-white/60 mt-3 text-sm">{c.description}</p>
                  {c.requirements && <p className="text-white/45 mt-1 text-xs">Kualifikasi: {c.requirements}</p>}
                </div>
                <a href={`https://wa.me/${s.whatsapp || "6281234567890"}?text=Halo, saya tertarik melamar posisi ${encodeURIComponent(c.title)}`} target="_blank" rel="noreferrer"
                  className="btn-gold px-6 py-3 rounded-full flex items-center gap-2 shrink-0 whitespace-nowrap" data-testid={`career-apply-${i}`}>
                  Lamar <ArrowRight className="w-4 h-4" />
                </a>
              </div>
            </Reveal>
          ))}
          {items.length === 0 && <p className="text-white/50">Belum ada lowongan tersedia saat ini.</p>}
        </div>
      </section>
    </div>
  );
}
